import React from 'react';
import { Link } from 'react-router-dom';

function SideNav_CourseList(props) {
    return (
        <section id="table" >
            <div className="table-container">
                <aside className="table-left">
                    <div className="subject">
                        <div className="subject-item"><Link to="/courseList">전체 강의</Link></div>
                        <div className="subject-item">
                            <div className="subject-item_title">
                                <div>개발 · 프로그래밍
                                    <span><iconify-icon icon="fe:arrow-right"></iconify-icon></span></div>
                            </div>
                            <div className="subject-item_sub list-hidden">
                                <div className="subject-item_link"><a href="/">ALL</a></div>
                                <div className="subject-item_link"><a href="/">웹 개발</a></div>
                                <div className="subject-item_link"><a href="/">프론트엔드</a></div>
                                <div className="subject-item_link"><a href="/">백엔드</a></div>
                                <div className="subject-item_link"><a href="/">풀스택</a></div>
                                <div className="subject-item_link"><a href="/">ALL</a></div>
                                <div className="subject-item_link"><a href="/">ALL</a></div>
                                <div className="subject-item_link"><a href="/">ALL</a></div>
                                <div className="subject-item_link"><a href="/">ALL</a></div>
                                <div className="subject-item_link"><a href="/">ALL</a></div>
                                <div className="subject-item_link"><a href="/">ALL</a></div>
                                <div className="subject-item_link"><a href="/">ALL</a></div>
                                <div className="subject-item_link"><a href="/">ALL</a></div>
                                <div className="subject-item_link"><a href="/">ALL</a></div>
                                <div className="subject-item_link"><a href="/">ALL</a></div>
                                <div className="subject-item_link"><a href="/">ALL</a></div>
                                <div className="subject-item_link"><a href="/">ALL</a></div>
                                <div className="subject-item_link"><a href="/">ALL</a></div>
                            </div>
                        </div>
                        <div className="subject-item">
                            <div className="subject-item_title">
                                <div>보안 · 네트워크
                                    <span><iconify-icon icon="fe:arrow-right"></iconify-icon></span></div>
                            </div>
                            <div className="subject-item_sub list-hidden">
                                <div className="subject-item_link"><a href="/">ALL</a></div>
                                <div className="subject-item_link"><a href="/">웹 개발</a></div>
                                <div className="subject-item_link"><a href="/">프론트엔드</a></div>
                                <div className="subject-item_link"><a href="/">백엔드</a></div>
                                <div className="subject-item_link"><a href="/">풀스택</a></div>
                            </div>
                        </div>
                        <div className="subject-item">
                            <div className="subject-item_title">
                                <div>데이터 사이언스
                                    <span><iconify-icon icon="fe:arrow-right"></iconify-icon></span></div>
                            </div>
                            <div className="subject-item_sub list-hidden">
                                <div className="subject-item_link"><a href="/">ALL</a></div>
                                <div className="subject-item_link"><a href="/">웹 개발</a></div>
                                <div className="subject-item_link"><a href="/">프론트엔드</a></div>
                                <div className="subject-item_link"><a href="/">백엔드</a></div>
                                <div className="subject-item_link"><a href="/">풀스택</a></div>
                            </div>
                        </div>
                        <div className="subject-item">
                            <div className="subject-item_title">
                                <div>게임 개발
                                    <span><iconify-icon icon="fe:arrow-right"></iconify-icon></span></div>
                            </div>
                            <div className="subject-item_sub list-hidden">
                                <div className="subject-item_link"><a href="/">ALL</a></div>
                                <div className="subject-item_link"><a href="/">웹 개발</a></div>
                                <div className="subject-item_link"><a href="/">프론트엔드</a></div>
                                <div className="subject-item_link"><a href="/">백엔드</a></div>
                                <div className="subject-item_link"><a href="/">풀스택</a></div>
                            </div>
                        </div>
                        <div className="subject-item">
                            <div className="subject-item_title">
                                <div>크리에이티브
                                    <span><iconify-icon icon="fe:arrow-right"></iconify-icon></span></div>
                            </div>
                            <div className="subject-item_sub list-hidden">
                                <div className="subject-item_link"><a href="/">ALL</a></div>
                                <div className="subject-item_link"><a href="/">웹 개발</a></div>
                                <div className="subject-item_link"><a href="/">프론트엔드</a></div>
                                <div className="subject-item_link"><a href="/">백엔드</a></div>
                                <div className="subject-item_link"><a href="/">풀스택</a></div>
                            </div>
                        </div>
                        <div className="subject-item">
                            <div className="subject-item_title">
                                <div>직무 · 마케팅
                                    <span><iconify-icon icon="fe:arrow-right"></iconify-icon></span></div>
                            </div>
                            <div className="subject-item_sub list-hidden">
                                <div className="subject-item_link"><a href="/">ALL</a></div>
                                <div className="subject-item_link"><a href="/">웹 개발</a></div>
                                <div className="subject-item_link"><a href="/">프론트엔드</a></div>
                                <div className="subject-item_link"><a href="/">백엔드</a></div>
                                <div className="subject-item_link"><a href="/">풀스택</a></div>
                            </div>
                        </div>
                        <div className="subject-item">
                            <div className="subject-item_title">
                                <div>학문 · 외국어
                                    <span><iconify-icon icon="fe:arrow-right"></iconify-icon></span></div>
                            </div>
                            <div className="subject-item_sub list-hidden">
                                <div className="subject-item_link"><a href="/">ALL</a></div>
                                <div className="subject-item_link"><a href="/">웹 개발</a></div>
                                <div className="subject-item_link"><a href="/">프론트엔드</a></div>
                                <div className="subject-item_link"><a href="/">백엔드</a></div>
                                <div className="subject-item_link"><a href="/">풀스택</a></div>
                            </div>
                        </div>
                        <div className="subject-item">
                            <div className="subject-item_title">
                                <div>커리어
                                    <span><iconify-icon icon="fe:arrow-right"></iconify-icon></span></div>
                            </div>
                            <div className="subject-item_sub list-hidden">
                                <div className="subject-item_link"><a href="/">ALL</a></div>
                                <div className="subject-item_link"><a href="/">웹 개발</a></div>
                                <div className="subject-item_link"><a href="/">프론트엔드</a></div>
                                <div className="subject-item_link"><a href="/">백엔드</a></div>
                                <div className="subject-item_link"><a href="/">풀스택</a></div>
                            </div>
                        </div>
                        <div className="subject-item">
                            <div className="subject-item_title">
                                <div>교양
                                    <span><iconify-icon icon="fe:arrow-right"></iconify-icon></span></div>
                            </div>
                            <div className="subject-item_sub list-hidden">
                                <div className="subject-item_link"><a href="/">ALL</a></div>
                                <div className="subject-item_link"><a href="/">웹 개발</a></div>
                                <div className="subject-item_link"><a href="/">프론트엔드</a></div>
                                <div className="subject-item_link"><a href="/">백엔드</a></div>
                                <div className="subject-item_link"><a href="/">풀스택</a></div>
                            </div>
                        </div>
                    </div>
                </aside>
            </div>            
        </section>
    );
}

export default SideNav_CourseList;